import React, { useState } from "react";
import { useSelector } from "react-redux";
import http from "../../../http-common";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateLeft } from "@fortawesome/free-solid-svg-icons";

export default function ArchivedEpkCard({ EpkInfo, onRestore }) {
  const { t } = useTranslation();
  const user = useSelector((state) => state.user);
  const [restoring, setRestoring] = useState(false);

  const handleRestore = () => {
    setRestoring(true);
    http
      .put(`/fepks/restore/${EpkInfo._id}`, {}, {
        headers: { Authorization: `Bearer ${user?.token}` },
      })
      .then(() => {
        toast.success(t("EPK successfully restored."));
        onRestore(EpkInfo._id);
      })
      .catch((err) => {
        console.error("Error restoring EPK:", err);
        toast.error(t("Failed to restore EPK."));
      })
      .finally(() => setRestoring(false));
  };

  return (
    <div className="tw-relative tw-flex tw-flex-col tw-rounded-xl tw-border tw-border-dashed tw-border-white/10 tw-bg-white/5 tw-p-4 tw-opacity-60 tw-transition-opacity hover:tw-opacity-90 tw-w-full tw-max-w-xs">
      <span className="tw-absolute tw-right-2 tw-top-2 tw-z-10 tw-rounded tw-bg-red-900/30 tw-px-2 tw-py-0.5 tw-text-xs tw-font-semibold tw-text-red-400">
        {t("Deleted")}
      </span>

      <div className="tw-mb-3 tw-mt-5 tw-h-24 tw-w-full tw-overflow-hidden tw-rounded-lg tw-bg-white/10">
        {EpkInfo.banner_url ? (
          <img
            src={`${process.env.REACT_APP_AWS_URL}/${EpkInfo.banner_url}`}
            alt={EpkInfo.title}
            className="tw-h-full tw-w-full tw-object-cover tw-grayscale"
          />
        ) : (
          <div className="tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center tw-text-white/30 tw-text-xs">
            {t("No Image")}
          </div>
        )}
      </div>

      <p className="tw-mb-3 tw-truncate tw-text-sm tw-font-semibold tw-text-white/50">
        {EpkInfo.title || t("Untitled EPK")}
      </p>

      <button
        onClick={handleRestore}
        disabled={restoring}
        className={`tw-mt-auto tw-flex tw-w-full tw-items-center tw-justify-center tw-gap-2 tw-rounded-lg tw-bg-[#712CB0] hover:tw-bg-[#8B3FD9] tw-px-3 tw-py-2 tw-text-xs tw-font-semibold tw-text-white tw-transition-colors tw-border-0 tw-cursor-pointer ${
          restoring ? "tw-cursor-not-allowed tw-opacity-50" : ""
        }`}
      >
        <FontAwesomeIcon icon={faRotateLeft} />
        {restoring ? t("Restoring...") : t("Restore")}
      </button>
    </div>
  );
}
